// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import React, { type ChangeEvent, useState } from 'react';
import { Box, Button, MUITextField } from '../../lib/base';

interface Props {
  readonly onFileSelect: (file: File) => void;
}

export default function FileUpload({ onFileSelect }: Props) {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      setSelectedFile(file);
      onFileSelect(file);
    }
    // Reset the value of the input so that the same file can be selected again
    event.target.value = '';
  };

  return (
    <Box
      display="flex"
      flexGrow={1}
      flexDirection={{ xs: 'column', sm: 'row' }}
      sx={{ alignItems: { xs: undefined, sm: 'center' }, gap: { xs: 1, sm: 0 } }}
    >
      <Box sx={{ pr: { xs: 0, sm: 1 } }}>
        <input
          accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          style={{ display: 'none' }}
          id="contained-button-file"
          type="file"
          onChange={handleFileChange}
        />
        <label htmlFor="contained-button-file">
          <Button fullWidth variant="contained" component="div" sx={{ textWrap: 'nowrap' }}>
            Select File
          </Button>
        </label>
      </Box>
      <MUITextField size="small" fullWidth disabled value={selectedFile?.name ?? 'No file selected'} />
    </Box>
  );
}
